module.exports = __webpack_public_path__ + "static/media/amt-logo.14438b25.png";